module.exports = __webpack_public_path__ + "img/onlineactivity.90bea55d.svg";